import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [consent, setConsent] = useState(false);
  const [optin, setOptin] = useState(true);
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { toast.error("Please accept the medical disclaimer & terms to continue."); return; }
    setLoading(true);
    try {
      await register({ ...form, consent, healing_blueprint_optin: optin });
      toast.success("Welcome to Silver Serenity — your free account is ready.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5 py-12">
      <div className="w-full max-w-md card-surface p-8">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6">
          <Sparkles className="text-brand-gold" /><span className="font-display text-3xl font-semibold">Isoharts</span>
        </Link>
        <h1 className="font-display text-3xl font-semibold text-center text-brand-ink">Create Your Free Account</h1>
        <p className="text-center text-brand-muted text-sm mt-1">Silver Serenity — free forever, no card required.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="signup-name" required placeholder="Full name" className="input-field" value={form.name} onChange={upd("name")} />
          <input data-testid="signup-email" type="email" required placeholder="Email" className="input-field" value={form.email} onChange={upd("email")} />
          <input data-testid="signup-password" type="password" required minLength={6} placeholder="Password (min 6 chars)" className="input-field" value={form.password} onChange={upd("password")} />
          <label className="flex items-start gap-2 text-xs text-brand-inksoft" data-testid="signup-consent">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-brand-sage" />
            <span>I understand this education is for personal self-development and is not a substitute for professional medical advice. I accept the <Link to="/terms" className="text-brand-sage underline">Terms</Link> & <Link to="/privacy-policy" className="text-brand-sage underline">Privacy Policy</Link>.</span>
          </label>
          <label className="flex items-start gap-2 text-xs text-brand-inksoft">
            <input type="checkbox" checked={optin} onChange={(e) => setOptin(e.target.checked)} className="mt-0.5 accent-brand-sage" />
            <span>Send me the free Healing Blueprint Guide & seasonal wellness emails.</span>
          </label>
          <button data-testid="signup-submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Creating…" : "Start Free"}
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-brand-muted">
          Already a member? <Link to="/login" className="text-brand-sage hover:underline" data-testid="to-login">Log in</Link>
        </p>
      </div>
    </div>
  );
}
